// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"45658e30","152":"054c8fea","234":"0da3095c","245":"5f7f99fa","314":"23e32966","412":"3099acc3","639":"bc9967b9","706":"9ed604c1","718":"97d9a99e","863":"ef95a0ef"}[chunkId] + ".chunk.css";
};